import React, { useContext } from "react";

import OrganizationPageHero from "../../../molecules/OrganizationPageHero";

import { ServiceCard } from "../../../atoms/Cards";
import { DarkFormField } from "../../../atoms/Inputs";

import { demoContext } from "../../../../shared/store/contexts";

const AllProgramsPage = () => {
  const { services } = useContext(demoContext);

  return (
    <main className="flex flex-col w-full">
      <div className="flex justify-between items-center">
        <OrganizationPageHero
          className="organization-container"
          title="Services"
          description="All Services"
        />
      </div>
      <section className="organization-container pb-10 flex-grow flex flex-col mt-6">
        <form className="md:w-3/5">
          <div className="flex flex-wrap lg:flex-no-wrap">
            <div className="w-full flex-grow">
              <DarkFormField
                type="search"
                id="query"
                name="query"
                className="py-1 flex w-full"
                placeholder="Search by service name"
                iconBeforeClass=""
                data_testid="query-input"
              />
            </div>
          </div>
        </form>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </section>
    </main>
  );
};

export default AllProgramsPage;
